import React, { useEffect, useState, useRef } from 'react'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
// import useAuth from '../../context/auth/useAuth'
import { useNavigate, useParams } from 'react-router-dom'
// import { addPaymentIntent, getOrder } from '../../actions/ordersActions'
import { getOrder, getPaymentFormParams } from '../../actions/ordersActions'
import Swal from 'sweetalert2'
// import {Elements} from '@stripe/react-stripe-js'
// import { StripeCheckoutForm } from '../../components/payment/StripeCheckoutForm'
// import { loadStripe } from '@stripe/stripe-js'
// import Axios from 'axios'


export default function PayOrderBrowser() {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const formRef = useRef(null)
	// const {client} = useAuth()

    const { orderId } = useParams()

	const {order, formParams, paymentStatus} = useSelector(state=>state.orders)

	// const [stripePromise, setStripePromise] = useState(null)
    // const [clientSecret, setClientSecret] = useState("")

	
    const [waitingForPayment, setWaitingForPayment] = useState(false)

	const [redsysParamsState, setRedsysParamsState] = useState(null)


	useEffect(() => {
		window.scrollTo({
            top:0,
            behavior: 'instant'
        })
		if(orderId){
			dispatch(getOrder(orderId))
		}
	},[dispatch, orderId])

	useEffect(() => {
		if (formParams) {
			if (formParams?.params) {
				setRedsysParamsState(formParams.params)
				dispatch({ type: 'ORDER_GET_PAYMENT_FORM_RESET' })
			} else {
				Swal.fire({
					showConfirmButton: true,
					icon: 'danger',
					text: t('client.orders.' + formParams?.message)
				})
			}
		}
	}, [formParams, dispatch, t])

	useEffect(() => {
		if (order?.isPaid === false) {
			dispatch(getPaymentFormParams(order._id))
		}
	}, [order, dispatch])

	useEffect(() => {
		if (paymentStatus?.isPaid || paymentStatus?.paymentStatus) {
			clearInterval(window.orderPaymentStatusInterval)
			setWaitingForPayment(false)
			dispatch({ type: 'ORDER_GET_PAYMENT_STATUS_RESET' })
            navigate('/client/pendingorders')
		}
	}, [paymentStatus, dispatch, navigate])

	
	useEffect(() => {
		if (redsysParamsState?.Ds_MerchantParameters) {
			formRef.current.submit()
		}
	}, [redsysParamsState])

	return (
        <Container className='p-5'>
			<Row className="text-start my-3">
				<Col>
					<Card className='my-2'>
						<Card.Body className='text-center'>
							{
								!order?.isPaid && redsysParamsState &&
								<>
									<div className="col-12 py-3">
										{/* Producción */}
										<form autoComplete='off' name="form" action="https://sis.redsys.es/sis/realizarPago" method="POST" ref={formRef}>
										{/* Desarrollo */}
										{/* <form autoComplete='off' name="form" action="https://sis-t.redsys.es:25443/sis/realizarPago" method="POST"  ref={formRef}> */}

											<input type="hidden" name="Ds_SignatureVersion" value={redsysParamsState.Ds_SignatureVersion} />
											<input type="hidden" name="Ds_MerchantParameters" value={redsysParamsState.Ds_MerchantParameters} />
											<input type="hidden" name="Ds_Signature" value={redsysParamsState.Ds_Signature} />
											<div className="d-grid gap-2">
												<Button type="submit" variant='primary'>
													{
														waitingForPayment
														?
															<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
														:
															t('admin.orders.pay')
													}
												</Button>
											</div>
										</form>

									</div>
								</>
							}
						</Card.Body>
					</Card>
				</Col>
			</Row>
        </Container>
	)
}